import { PermissionsEnum } from "app/global/permissions/permissions.enum";

export const accessToSettingsPermissions = {
    'APIsettings': 'settings_api_settings',
    'branding': 'settings_branding',
    'categories': 'settings_category',
    'Add_Ons': 'settings_add_ons',
    'general': 'settings_general',
    'contentlibrary': 'settings_content_library',
    'MD': 'settings_meta_data',
    'documenttype': 'settings_document_type',
    'productlibrary': 'settings_product_library'
}


export const settingsPermissions = [
    PermissionsEnum.settings_api_settings,
    PermissionsEnum.settings_branding,
    PermissionsEnum.settings_category,
    PermissionsEnum.settings_general,
    PermissionsEnum.settings_content_library,
    PermissionsEnum.settings_meta_data,
    PermissionsEnum.settings_document_type,
    PermissionsEnum.settings_product_library
];